import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Importações do Firebase
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { auth, firestore } from './firebase/config';
import { doc, getDoc } from 'firebase/firestore';

// Importação das suas páginas
import Login from './pages/Login';
import AgenteDashboard from './pages/AgenteDashboard';
import GestorDashboard from './pages/GestorDashboard';
import LaboratorioDashboard from './pages/LaboratorioDashboard';
import SupervisorDashboard from './pages/SupervisorDashboard';
import Loading from './components/Loading'; // Um componente de "Carregando..."

function App() {
  const [user, setUser] = useState(null); // Agora teremos um único estado para o usuário
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (authUser) => {
      if (authUser) {
        try {
          // 1. Tenta buscar o perfil no Firestore (Online)
          const userDocRef = doc(firestore, "usuarios", authUser.uid);
          const userDoc = await getDoc(userDocRef);

          if (userDoc.exists()) {
            const userData = {
              uid: authUser.uid,
              email: authUser.email,
              ...userDoc.data()
            };

            // Verifica se a conta está inativa
            if (userData.status === 'inativo') {
              await signOut(auth);
              alert("Sua conta foi desativada pelo administrador.");
              setUser(null);
              setLoading(false);
              return;
            }

            // Salva no localStorage para uso offline futuro
            localStorage.setItem('userProfile', JSON.stringify(userData));

            setUser(userData);
          } else {
            // Perfil não existe no Firestore
            setUser(authUser);
            console.warn("Usuário autenticado, mas sem perfil correspondente no Firestore.");
          }
        } catch (error) {
          console.warn("Erro ao buscar perfil no Firestore (possivelmente offline). Tentando cache local...", error);

          // 2. Fallback: Tenta recuperar do localStorage (Offline)
          const cachedUser = localStorage.getItem('userProfile');
          if (cachedUser) {
            const parsedUser = JSON.parse(cachedUser);
            // Verifica se o cache pertence ao usuário autenticado atual
            if (parsedUser.uid === authUser.uid) {
              setUser(parsedUser);
              console.log("Perfil carregado do cache local (Offline Mode).");
            } else {
              setUser(authUser); // Cache inválido ou de outro usuário
            }
          } else {
            setUser(authUser); // Sem cache, usa dados básicos
          }
        }
      } else {
        // 4. Se o usuário deslogou, limpa o estado e o cache
        setUser(null);
        localStorage.removeItem('userProfile');
      }
      setLoading(false);
    });

    // Função de limpeza
    return () => unsubscribe();
  }, []); // O array vazio [] garante que isso rode apenas uma vez

  // Enquanto a verificação inicial acontece, mostra uma tela de "Carregando..."
  if (loading) {
    return <Loading />;
  }

  // --- Lógica de Roteamento (Ajustada para ler do objeto 'user' unificado) ---
  return (
    <Router>
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />

        <Route
          path="/"
          element={
            !user ? <Navigate to="/login" /> :
              user.perfil === 'agente' ? <AgenteDashboard user={user} /> :
                (user.perfil === 'gestor' || user.perfil === 'master') ? <GestorDashboard user={user} /> :
                  user.perfil === 'laboratorio' ? <LaboratorioDashboard user={user} /> :
                    user.perfil === 'supervisor' ? <SupervisorDashboard user={user} /> :
                      // Se o usuário está logado mas não tem um perfil válido, mostra uma mensagem
                      <Loading message={`Bem-vindo ${user.email}. Seu perfil não foi encontrado ou é inválido.`} />
          }
        />
        {/* Adicione outras rotas aqui, se necessário */}
      </Routes>
    </Router>
  );
}

export default App;